import React from 'react';
import VolCurve from '../components/VolCurve/VolCurve';

function VolCurveView() {
  return (
    <div className="vol-curve-view">
      <VolCurve />
    </div>
  );
}

export default VolCurveView;
